import React from 'react';
import {Link} from "react-router-dom"

const Logo = () => {
  return (
<Link to="/">
		  
		<svg
		  version='1.1'
		  id='Layer_1'
		  x='0px'
		  y='0px'
		  style={{ maxWidth: '23vw', width: 'calc(109px)' }}
		  viewBox='0 0 138.634 46.255'
		  enableBackground='new 0 0 138.634 46.255'
		  xmlSpace='preserve'
		>
		  <g>
			<path
			  fill='#FFFFFF'
			  d='M19.975,21.344c0,2.913-0.735,5.13-2.204,6.65c-1.47,1.52-3.661,2.28-6.574,2.28
			c-1.799,0-3.363-0.336-4.693-1.007s-2.35-1.621-3.059-2.85c-0.709-1.229-1.064-2.666-1.064-4.313v-0.684h5.396
			c0,1.343,0.259,2.325,0.779,2.945c0.519,0.621,1.324,0.931,2.413,0.931c0.861,0,1.514-0.184,1.957-0.551
			c0.443-0.367,0.734-0.83,0.874-1.387c0.139-0.557,0.209-1.229,0.209-2.014V3.408h5.966V21.344z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M29.798,5.764c-0.266,0.456-0.64,0.817-1.121,1.083c-0.481,0.266-1.026,0.399-1.634,0.399
			s-1.153-0.133-1.634-0.399c-0.482-0.266-0.855-0.627-1.121-1.083s-0.399-0.975-0.399-1.558c0-0.583,0.133-1.102,0.399-1.558
			s0.639-0.817,1.121-1.083c0.481-0.266,1.026-0.399,1.634-0.399s1.152,0.133,1.634,0.399c0.481,0.266,0.855,0.627,1.121,1.083
			c0.266,0.456,0.399,0.976,0.399,1.558C30.197,4.789,30.064,5.308,29.798,5.764z M29.741,10.02v19.646h-5.396V10.02H29.741z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M51.552,25.314c-0.836,1.558-2.001,2.762-3.496,3.61c-1.495,0.849-3.217,1.273-5.168,1.273
			c-2.001,0-3.75-0.431-5.244-1.292c-1.495-0.861-2.647-2.071-3.458-3.629c-0.811-1.558-1.216-3.363-1.216-5.415
			c0-2.077,0.405-3.895,1.216-5.453c0.811-1.558,1.963-2.768,3.458-3.629c1.495-0.861,3.243-1.292,5.244-1.292
			c2.001,0,3.749,0.431,5.244,1.292c1.495,0.862,2.647,2.078,3.458,3.648c0.811,1.571,1.216,3.382,1.216,5.434
			C52.806,21.939,52.388,23.756,51.552,25.314z M46.251,24.459c0.772-1.089,1.159-2.622,1.159-4.598c0-1.824-0.355-3.325-1.064-4.503
			c-0.709-1.178-1.875-1.767-3.496-1.767c-1.419,0-2.521,0.545-3.306,1.634c-0.786,1.089-1.178,2.635-1.178,4.636
			c0,2.002,0.386,3.541,1.159,4.617c0.772,1.077,1.894,1.615,3.363,1.615S45.478,25.549,46.251,24.459z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M64.814,3.408l5.928,17.784h0.076L76.48,3.408h8.398v26.258h-5.586v-18.43h-0.076l-6.27,18.43h-4.598
			l-6.27-18.278h-0.076v18.278h-5.586V3.408H64.814z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M100.952,16.784c0-1.292-0.247-2.236-0.741-2.831c-0.494-0.595-1.349-0.893-2.565-0.893
			c-1.064,0-1.875,0.19-2.432,0.57c-0.558,0.38-0.887,0.976-0.988,1.786h-5.358c0.101-1.925,0.95-3.401,2.546-4.427
			c1.596-1.026,3.762-1.539,6.498-1.539c2.913,0,5.048,0.621,6.403,1.862c1.355,1.242,2.033,3.192,2.033,5.852v12.502h-4.864
			l-0.304-2.546h-0.076c-0.431,0.887-1.159,1.622-2.185,2.204c-1.026,0.582-2.312,0.874-3.857,0.874
			c-1.368,0-2.565-0.241-3.591-0.722c-1.026-0.481-1.818-1.19-2.375-2.128c-0.558-0.937-0.836-2.064-0.836-3.382
			c0-2.204,0.842-3.825,2.527-4.864c1.685-1.039,4.098-1.558,7.239-1.558h2.926V16.784z M98.748,20.735
			c-1.647,0-2.901,0.216-3.762,0.646c-0.861,0.431-1.292,1.153-1.292,2.166c0,0.887,0.272,1.552,0.817,1.995
			c0.544,0.443,1.286,0.665,2.223,0.665c0.811,0,1.539-0.165,2.185-0.494c0.646-0.329,1.146-0.804,1.501-1.425
			c0.354-0.621,0.532-1.374,0.532-2.261v-1.292H98.748z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M122.498,14.731c-0.178-0.05-0.406-0.095-0.684-0.133c-0.279-0.038-0.608-0.057-0.988-0.057
			c-1.799,0-3.148,0.57-4.047,1.71c-0.899,1.14-1.349,2.66-1.349,4.56v8.854h-5.396V10.02h5.13v3.648h0.076
			c0.456-1.267,1.184-2.28,2.185-3.04c1-0.76,2.16-1.14,3.477-1.14c0.608,0,1.14,0.064,1.596,0.19V14.731z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M131.047,10.02h3.838v3.61h-3.838v8.664c0,0.912,0.088,1.615,0.266,2.109
			c0.177,0.494,0.449,0.836,0.817,1.026c0.367,0.19,0.842,0.285,1.425,0.285c0.506,0,0.988-0.063,1.444-0.19v4.142
			c-0.735,0.228-1.583,0.342-2.546,0.342c-2.179,0-3.857-0.538-5.035-1.615c-1.178-1.077-1.767-2.881-1.767-5.415v-9.348h-3.154
			v-3.61h3.154v-5.89h5.396V10.02z'
			/>
		  </g>
		  <g>
			<path
			  fill='#FFFFFF'
			  d='M110.669,35.142c0.498,0.363,0.748,0.918,0.748,1.663c0,0.46-0.117,0.854-0.351,1.184
			s-0.563,0.576-0.988,0.741v0.025c0.555,0.13,0.982,0.391,1.281,0.78s0.448,0.871,0.448,1.443c0,0.563-0.136,1.04-0.409,1.43
			s-0.648,0.683-1.125,0.877c-0.477,0.195-1.023,0.293-1.638,0.293h-4.212v-8.983h4.121C109.462,34.595,110.17,34.778,110.669,35.142
			z M109.44,38.014c0.26-0.208,0.39-0.507,0.39-0.896c0-0.416-0.132-0.724-0.396-0.923c-0.265-0.199-0.652-0.299-1.164-0.299h-2.223
			v2.431h2.314C108.821,38.327,109.18,38.222,109.44,38.014z M110.181,40.887c0-0.459-0.147-0.808-0.442-1.046
			s-0.719-0.357-1.274-0.357h-2.418v2.795h2.392C109.601,42.279,110.181,41.815,110.181,40.887z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M119.646,34.595v1.378h-4.953v2.341h4.576v1.287h-4.576v2.6h5.044v1.378h-6.669v-8.983H119.646z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M127.458,34.595v1.378h-2.847v7.605h-1.625v-7.605h-2.834v-1.378H127.458z'
			/>
			<path
			  fill='#FFFFFF'
			  d='M131.58,34.595l3.419,8.983h-1.69l-0.819-2.223h-3.588l-0.832,2.223h-1.664l3.484-8.983H131.58z
			 M130.708,36.389l-1.378,3.719h2.73l-1.326-3.719H130.708z'
			/>
		  </g>
		</svg>
</Link>
  );
};

export default Logo;
